import { Component, OnInit, ChangeDetectionStrategy, ChangeDetectorRef } from '@angular/core';
import { Store } from '../models/store';
import { ActivatedRoute, Router } from '@angular/router';
import { OrderService } from '../order.service';
import {MatSnackBar} from '@angular/material/snack-bar';

@Component({
  selector: 'app-offer-v2',
  templateUrl: './offer-v2.component.html',
  styleUrls: ['./offer-v2.component.sass'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class OfferV2Component implements OnInit {

  storeId:string;
  offerOrderId:string;
  store:Store;
  offers:any[];
  navigationSubscription;
  offerCatalogSharableLink;
  isLoading = true;
  offerOrder;
  userHash:string;
  phoneNumber: string;

  orderId:string;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private orderService:OrderService,
    private snackBar: MatSnackBar,
    private cdr: ChangeDetectorRef
  ) { }

  ngOnInit(): void {
    this.orderId = this.route.snapshot.paramMap.get('orderId');
    this.storeId = this.route.snapshot.paramMap.get('storeId');
    this.orderService.getStoreInfo(this.storeId).subscribe(store => {
      this.store = Object.assign(new Store(), store);
      this.orderService.getOffersV2(this.storeId).subscribe(offers => {
        this.offers = offers.data;
        (this.offers || []).filter(o => !o.private).forEach(o => this.track(o, 'VIEWED'));
        this.cdr.markForCheck();
      })
      this.isLoading = false;
      this.cdr.markForCheck();
    });

    this.userHash = localStorage.getItem('userHash')
    this.phoneNumber = localStorage.getItem('phoneNumber')
  }

  private track(offer, event: 'VIEWED' | 'CLICKED') {
    if (!offer?.id) return;
    this.orderService.trackOffer(this.storeId, offer.id, event).subscribe({ error: () => {} });
  }

  copyMessage(val: string, offer = null){
    if (offer) this.track(offer, 'CLICKED');
    navigator.clipboard.writeText(val).then(() => {
      this.snackBar.open(`Promo code '${val}' copied!`, "OK", {
        duration: 2000,
        verticalPosition: 'top'
      });
    });
  }

  isNextVisit(offer){
    return offer.redemption_timing === 'NEXT_VISIT';
  }

  useOffer(offer){
    this.track(offer, 'CLICKED');
    if(this.orderId){
      this.orderService.applyPromoCode(this.orderId, offer.promo_code).subscribe({
        next: () => this.router.navigate(['order', this.orderId]),
        error: (err) => this.snackBar.open(err?.error?.message || "This offer can't be used right now.", 'OK', {
          duration: 4000,
          verticalPosition: 'top'
        })
      })
    }else{
      this.orderService.createTempOrderWithPhone(this.store.url_slug, this.phoneNumber, offer.promo_code).subscribe(response => {
        this.router.navigate(['order', response['order_hash'], 'store', response['url_slug']])
      })
    }

  }

  goBack(){}

}
